// Lightweight event tracking wrapper around Umami (privacy-first, cookieless,
// no consent banner). Umami loads asynchronously from public/index.html, so
// window.umami can be undefined on an early click. Every call is therefore a
// safe no-op until the script is ready, and analytics can never break a user
// action or throw into the UI.
export function track(event, data) {
	try {
		if (typeof window !== "undefined" && window.umami) {
			if (data) {
				window.umami.track(event, data);
			} else {
				window.umami.track(event);
			}
		}
	} catch (e) {
		// Swallow: a tracking failure must never interrupt what the user did.
	}
}
